// eslint-disable-next-line
import astra from '../../assets/images/logos/astrazeneca.svg';
// eslint-disable-next-line
import lilly from '../../assets/images/logos/lilly.svg';
// eslint-disable-next-line
import nova from '../../assets/images/logos/novartis.svg';
// eslint-disable-next-line
import roche from '../../assets/images/logos/roche.svg';
// eslint-disable-next-line
import sanofi from '../../assets/images/logos/sanofi.svg';
import genentech from '../../assets/images/logos/genentech.svg';
import merck from '../../assets/images/logos/merck.svg';
import ingeneron from '../../assets/images/logos/ingeneron.svg';
import exactSciences from '../../assets/images/logos/exact_sciences.svg';

export const textBlockData = {
  header: ["Millions of lives benefit from successful clinical trials and it’s all because of the volunteers."],
  copy: []
}

export const logosData = {
  header: "Join Clinical trials from trusted names like:",
  logoUrls: [
    genentech,
    merck,
    exactSciences,
    ingeneron
  ]
}

export const infoCTAData = {
  header: "What is a clinical trial?", 
  copy: ["Clinical trials, also known as research studies, are a type of medical research that help healthcare professionals bring new treatments to people around the world.","At StudyKIK, we're here to help you find a study that's right for you, and are committed to make the process of finding and joining a clinical trial safe, secure and easy to understand."], 
  buttonText: "Find a Study"
}

export const textBlockData2 = {
  header: ["StudyKIK's mission is to make a difference in the world by getting new treatments to people faster through education and innovative technology."],
  copy: []
}

export const blockCTAData = {
  textBlockData: {
    header: ["Who is StudyKIK?"],
    copy: ["We believe that all patients should have the power to access the most advanced healthcare available. But we understand that getting started on the journey can be daunting. We’re not only here to help you start, we'll be with you every step of the way."],
  },
  ctaLink: {
    text: "Learn More About StudyKIK",
    url: "/patients/what-is-studykik"
  }
}

export const SEOData = {
  title: "Full Service Patient Recruitment and Retention Technology Company - StudyKIK",
  description: "StudyKIK's mission is to make a difference in the world by getting new treatments to people faster through education and innovative technology.",
  keywords: "StudyKIK, find a clinical trial, find trials, clinical trial, trials, research study, find a study, study, studies, medical research, healthcare, participants, patients, volunteers, patient recruitment, treatment, eConsent, sites, sponsors, learn about clinical trials, patient retention, patient enrollment, clinical trials near me, clinical trials near you, paid studies, paid studies near you"
}

